// angular
import {Routes} from "@angular/router";
// components
import {LayoutComponent} from "./layout/layout.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {ProfileComponent} from "./profile/profile.component";
import {LoginComponent} from "./+authentication/login/login.component";
import {ForgotPasswordComponent} from "./+authentication/forgot-password/forgot-password.component";
// constants & guards
import {appRoutes} from "./shared/constants/routes";
import {AuthGuard} from "./core/guards/auth.guard";
import {OrderListComponent} from "./+order/list/order-list.component";
import {CustomersListComponent} from "./+customer/list/customers-list.component";

export const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        title: "Dashboard",
        component: DashboardComponent,
        canActivate: [],
        data: {pageTitle: "dashboard.title"},
      },
      {
        path: "profile",
        title: "Profile",
        component: ProfileComponent,
        // canActivate: [RoleGuard],
        data: {pageTitle: "profile.title"},
      },
      {
        path: appRoutes.customers,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@customer/customer.routes").then((m) => m.CustomerRoutes),
      },
      {
        path: appRoutes.capillary,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@capillary/capillary.routes").then((m) => m.CapillaryRoutes),
      },
      {
        path: appRoutes.accounting,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@accounting/accounting.routes").then(
            (m) => m.AccountingRoutes
          ),
      },
      {
        path: appRoutes.productionManagement,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@production-management/production-management.routes").then(
            (m) => m.ProductionManagementRoutes
          ),
      },
      {
        path: appRoutes.productsPrices,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@products-prices/products-prices.routes").then(
            (m) => m.ProductsPricesRoutes
          ),
      },
      {
        path: appRoutes.requests,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@requests/requests.routes").then((m) => m.RequestsRoutes),
      },
      {
        path: appRoutes.returnRequests,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@return-requests/return-requests.routes").then(
            (m) => m.ReturnRequestsRoutes
          ),
      },
      {
        path: appRoutes.orders,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@order/order.routes").then((m) => m.OrderRoutes),
      },
      {
        path: appRoutes.onlineCustomers,
        // canActivate: [RoleGuard],
        component: CustomersListComponent,
        data: {
          pageTitle: "customers.list.onlineCustomers",
          id: "onlineCustomers",
        },
      },
      {
        path: appRoutes.onlineOrders,
        // canActivate: [RoleGuard],
        component: OrderListComponent,
        data: {pageTitle: "orders.list.onlineOrders", id: "onlineOrders"},
      },
      {
        path: appRoutes.warehouse,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@warehouse/warehouse.routes").then((m) => m.WarehouseRoutes),
      },
      {
        path: appRoutes.reports,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@reports/reports.routes").then((m) => m.ReportRoutes),
      },
      {
        path: appRoutes.stats,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@stats/stats.routes").then((m) => m.StatsRoutes),
      },
      {
        path: appRoutes.messaging,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@messaging/messaging.routes").then((m) => m.MessagingRoutes),
      },
      {
        path: appRoutes.smsManagement,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@sms-management/sms-management.routes").then(
            (m) => m.SmsManagementRoutes
          ),
      },
      {
        path: appRoutes.ticketManagement,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@ticket-management/ticket-management.routes").then(
            (m) => m.TicketManagementRoutes
          ),
      },
      {
        path: appRoutes.reminder,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@reminder/reminder.routes").then((m) => m.ReminderRoutes),
      },
      {
        path: appRoutes.user,
        // canActivate: [RoleGuard],
        loadChildren: () =>
          import("@user/user.routes").then((m) => m.UserRoutes),
      },
    ],
  },
  {
    path: "login",
    component: LoginComponent,
    data: {pageTitle: "auth.title"},
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    data: {pageTitle: "auth.forgotPassword"},
  },
  // {
  //   path: "404",
  //   component: NotFoundComponent,
  //   data: {pageTitle: "routes.notFound"},
  // },
  // {
  //   path: "**",
  //   component: NotFoundComponent,
  //   data: {pageTitle: "routes.notFound"},
  // },
];
